/* eslint-disable no-unused-vars */
import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      gap={2}
    >
      <CircularProgress size={60} sx={{ color: '#e42200' }} />
      <Typography variant="h6" sx={{ color: '#e42200', fontWeight: 'bold' }}>
        Loading...
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;
